export default __webpack_public_path__ + "static/media/praktika-branco.6e03be72.png";